import React from 'react';
import { View } from 'react-native';
import Button from 'src/components/Button/Button';
import { styles } from './SwitchButtons.styles';
import Typography from 'src/components/Text/Text';
import { useDesktopLayout } from 'src/hooks/useDesktopLayout';

interface SwitchButtonsProps {
  active: boolean;
  onChange: (value: boolean) => void;
  buttonLeftText?: string;
  buttonRightText?: string;
  title: string;
  testID?: string;
}

const SwitchButtons: React.FC<SwitchButtonsProps> = ({
  active,
  buttonLeftText = 'Yes',
  buttonRightText = 'No',
  title,
  onChange,
  testID,
}) => {
  const { screenWidth, contentMaxWidth } = useDesktopLayout();
  const effectiveWidth = contentMaxWidth ? Math.min(screenWidth, contentMaxWidth) : screenWidth;
  const buttonWidth = (effectiveWidth / 2 - 8) / 2;

  return (
    <View>
      <Typography style={styles.text} variant="title3">
        {title}
      </Typography>
      <View style={styles.buttonContainer}>
        <View style={{ width: buttonWidth }}>
          <Button
            testID={`button-left-${testID}-${buttonLeftText}`}
            style={styles.firstButton}
            type={active ? 'secondary' : 'tertiary'}
            title={buttonLeftText}
            onPress={() => onChange(true)}
          />
        </View>
        <View style={{ width: buttonWidth }}>
          <Button
            testID={`button-right-${testID}-${buttonRightText}`}
            type={active ? 'tertiary' : 'secondary'}
            title={buttonRightText}
            onPress={() => onChange(false)}
          />
        </View>
      </View>
    </View>
  );
};

export default SwitchButtons;
